import authFetch from './authFetch';
import { DECK_FORMAT_RULES, isBasicLand } from './deckRules';

export const validateCollectionForDeck = async (collectionId, selectedCard, collections, setWarnings) => {
  const col = collections.find((c) => c.id === collectionId);
  setWarnings([]);

  if (!col || col.type !== 'DECK' || !selectedCard) {
    return;
  }

  const formatRules = DECK_FORMAT_RULES[col.deck_type];
  if (!formatRules || col.deck_type === 'OTHER') {
    return;
  }

  try {
    const response = await authFetch(`/collections/${collectionId}?limit=1000`);
    if (!response.ok) {
      return;
    }
    const details = await response.json();

    const validationWarnings = [];

    if (formatRules.scryfallLegalityKey) {
      const legality = selectedCard.legalities?.[formatRules.scryfallLegalityKey];
      if (legality !== 'legal' && legality !== 'restricted' && !isBasicLand(selectedCard.name)) {
        validationWarnings.push(
          `This card is not legal in ${formatRules.name}`
        );
      }
    } else if (col.deck_type === 'PLANAR_STANDARD') {
      if (formatRules.bannedCards && formatRules.bannedCards.includes(selectedCard.name)) {
        validationWarnings.push(
          `This card is banned in Planar Standard`
        );
      }
      if (formatRules.legalSets && selectedCard.set && !formatRules.legalSets.includes(selectedCard.set)) {
        validationWarnings.push(
          `This card is not from a legal set in Planar Standard`
        );
      }
    } else if (col.deck_type === 'OATHBREAKER') {
      const legality = selectedCard.legalities?.oathbreaker;
      if (legality !== 'legal' && legality !== 'restricted' && !isBasicLand(selectedCard.name)) {
        validationWarnings.push(
          `This card is not legal in Oathbreaker`
        );
      }
    }

    const existingEntries = details.entries || [];
    let entriesWithCardData = [];
    if (existingEntries.length > 0) {
      try {
        const cardBatch = await authFetch('/cards/collection', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            identifiers: existingEntries.map(e => ({ id: e.scryfall_id })),
          }),
        });
        if (cardBatch.ok) {
          const { data: scCards } = await cardBatch.json();
          entriesWithCardData = existingEntries.map(e => ({
            ...e,
            cardName: scCards.find(c => c.id === e.scryfall_id)?.name || null,
          }));
        } else {
          entriesWithCardData = existingEntries;
        }
      } catch (err) {
        console.error('Failed to fetch card data for copy limit check:', err);
        entriesWithCardData = existingEntries;
      }
    }

    const existingCopies = entriesWithCardData
      .filter((e) => e.cardName === selectedCard.name)
      .reduce((sum, e) => sum + (e.quantity || 1), 0);

    if (
      formatRules.maxCopies !== null &&
      !isBasicLand(selectedCard.name) &&
      existingCopies + 1 > formatRules.maxCopies
    ) {
      validationWarnings.push(
        `Adding this card would exceed the ${formatRules.maxCopies}-copy limit for ${formatRules.name}`
      );
    }

    setWarnings(validationWarnings);
  } catch (err) {
    console.error('Failed to validate collection:', err);
  }
};
